import React from "react";

import { cn } from "../../../../lib/utils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBan, faCircleInfo} from "@fortawesome/pro-solid-svg-icons";
import {Popover, PopoverContent, PopoverTrigger} from "../../ui/Popover";

const Cill = ({ methods, isOpen: { Cill } }) => {
    const CILLS = ['none',"95", "150", "190"];
    const { register } = methods;
    return (
        <div
            className={cn(
                "section flex flex-col gap-4 overflow-hidden transition-all h-0 opacity-0",
                {
                    ["h-full opacity-100"]: Cill.isOpen,
                }
            )}
        >
            <div className='relative py-2'>
                <div className="absolute top-1 left-0 w-full h-full z-10">
                    <Popover>
                        <PopoverTrigger>
                            <FontAwesomeIcon className="text-primary absolute top-0 left-0" icon={faCircleInfo}/>
                        </PopoverTrigger>
                        <PopoverContent className='text-center'>Choose an appropriate cill depth based on the door threshold.</PopoverContent>
                    </Popover>
                </div>
            </div>
            <div className="grid grid-cols-3 gap-4">
                {CILLS.map((cill) => {
                    return (
                        <div key={cill} className="group">
                            <div className="relative flex flex-col items-center group-has-[:checked]:bg-[#555454] p-1">
                                {cill === 'none' ? (
                                    <div className='h-20 w-full flex items-center justify-center'>
                                        <FontAwesomeIcon className='w-full h-12 text-gray-600 group-has-[:checked]:text-white' icon={faBan}/>
                                    </div>
                                ) :
                                    <div className='flex h-20 items-center justify-center'>
                                        <img
                                            className="object-contain w-full h-20"
                                            src={`/assets/cill/${cill}.png`}
                                            alt="cill"
                                        />
                                    </div>
                                }

                                <input
                                    className="absolute inset-0 h-full w-full opacity-0 z-10 cursor-pointer"
                                    type="radio"
                                    value={cill}
                                    {...register("cill")}
                                />
                                <p className="text-gray-600 text-xs  group-has-[:checked]:text-white">
                                    {cill} {cill !=='none' && "mm"}
                                </p>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Cill;
